import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

function ConnectedDuration({ id, currentAutomix, isFullTrack, previewStartMs }) {
  const [time, setTime] = useState(0);

  useEffect( () => {
    let currentTime = 0;
    if (parseInt(currentAutomix.currentid) === parseInt(id)) {
      currentTime = (isFullTrack) ? currentAutomix.position : (previewStartMs / 1000) + currentAutomix.position;
    } else if (parseInt(currentAutomix.mixingid) === parseInt(id)) {
      currentTime = (isFullTrack) ? currentAutomix.mixingpos : (previewStartMs / 1000) + currentAutomix.mixingpos;
    }
    if (currentTime !== 0) {
      setTime(currentTime);
    }
  }, [id, currentAutomix, isFullTrack, previewStartMs])

  const format = (time) => {
    var sec_num = parseInt(time, 10);
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);
    // if (minutes < 10) {minutes = "0" + minutes;}
    if (seconds < 10) {seconds = "0" + seconds;}
    return `${minutes}:${seconds}`;
  }

  return format(time);
}

ConnectedDuration.propTypes = {
  id: PropTypes.number.isRequired,
  currentAutomix: PropTypes.any.isRequired,
  isFullTrack: PropTypes.bool.isRequired,
  previewStartMs: PropTypes.number.isRequired,
}

const Duration = connect(
  state => ({
    currentAutomix: state.currentAutomix,
  })
)(ConnectedDuration);

export default Duration;
